{
  "0x0ddfd8da": "EVC_ControlCollateralReentrancy",
  "0x3572cf8c": "TooManyElements",
  "0x38ae747c": "EVC_EmptyError",
  "0x44263592": "EVC_PermitDisabledMode",
  "0x4cd2d4f3": "EVC_BatchPanic",
  "0x5217b8ae": "EVC_OnBehalfOfAccountNotAuthenticated",
  "0x63df8171": "InvalidIndex",
  "0x655156bd": "EVC_InvalidOperatorStatus",
  "0x7c1b2908": "EVC_ChecksReentrancy",
  "0x7c9bb1cb": "EVC_InvalidTimestamp",
  "0x8133abd1": "EVC_InvalidAddress",
  "0xa82b84bb": "EVC_InvalidNonce",
  "0xb39e1e6e": "ControllerDisabled",
  "0xb83566c5": "EVC_SimulationBatchNested",
  "0xbb6de1c7": "EVC_InvalidValue",
  "0xd4b0e4d3": "EVC_RevertedBatchResult",
  "0xd80a9cac": "EVC_LockdownMode",
  "0xe07f2e6b": "EVC_NotAuthorized",
  "0xe85c620e": "EVC_InvalidData",
  "0xea8e4eb5": "NotAuthorized",
  "0xf1be4519": "EVC_ControllerViolation"
}
